import { Voltage } from "../enums/voltage";

export class SubstationTemplateForSelectDataOut{
    id: number | null;
    className: string;
    voltageClass: Voltage;
    count: number;

    constructor(data?: any){
        this.id = data?.substationTemplateId;
        this.className = data?.substationTemplateName;
        this.voltageClass = this.mapStringToVoltage(data?.voltageClass);
        this.count = data?.count;
    }

    mapStringToVoltage(voltageString: string): Voltage {
        const voltageMap: { [key: string]: Voltage } = {
            'LV': Voltage.LV,
            'MV': Voltage.MV,
            'HV': Voltage.HV
        };
        
        return voltageMap[voltageString] || Voltage.LV;
    }
}